import { DeviceErrors } from "@minervaproject/avsubsystem-core";

import { CpuModelAndScoreType } from "./hardware_monitor";

export enum PreclassTestNameType {
  AUDIO_LEVEL = "audio_level",
  BROWSER = "browser",
  CPU_SCORE = "cpu_score",
  CPU_CORES = "cpu_cores",
  EXCEPTION = "exception",
  EXTENSION = "extension",
  MIC_ACCESS_ALLOWED = "mic_access_allowed",
  CAMERA_ACCESS_ALLOWED = "camera_access_allowed",
  MIC_CAMERA_PREFERENCES = "mic_camera_preferences",
  ENUMERATE_DEVICES = "enumerate_devices",
  ACCESS_NOT_ALLOWED = "access_not_allowed",
  OTHER_APPS_USING_CAMERA = "other_apps_using_camera",
  CONNECTION = "connection",
  TOTAL_MEMORY = "total_memory",
  FORUM_REQUEST = "forum_request",
}

export enum PreclassTestCategoryType {
  SOFTWARE = "software",
  HARDWARE = "hardware",
  CONNECTION = "connection",
  MIC_AND_CAMERA = "mic_and_camera",
  UNEXPECTED = "unexpected",
}

export enum PreclassTestSpecificErrorsType {
  WRONG_BROWSER = "wrong_browser",
  OLD_BROWSER = "old_browser",

  AUDIO_LEVEL_NOT_DETECTED = "audio_level_not_detected",

  SLOW_NETWORK = "slow_network",
  LOW_CPU_SCORE = "low_cpu_score",
  LOW_CPU_CORES = "low_cpu_cores",
  LOW_MEMORY = "low_memory",

  AV_CONNECTION_FATAL = "av_connection_fatal",
  AV_CONNECTION_RETRYING = "av_connection_retrying",

  EXTENSION_FAILED_INJECT = "extension_failed_inject",
  EXTENSION_NOT_INSTALLED = "extension_not_installed",
  EXTENSION_INSTALL_SKIPPED = "extension_install_skipped",

  FAILED_FORUM_REQUEST = "failed_forum_request",

  UNEXPECTED_EXCEPTION = "unexpected_exception",
}

export enum PreclassTestResultSeverityType {
  SKIPPABLE = "skippable",
  NONSKIPPABLE = "nonskippable",
}

export type PreclassTestResultMessageType = {
  alertKind: "info" | "error" | "success";
  severity?: PreclassTestResultSeverityType;
  message: string;
  action: string;
  link?: string;
};

export type PreclassTestErrorsType = PreclassTestSpecificErrorsType | DeviceErrors;

export enum PreclassTestOutcomeType {
  NA = "na",
  SUCCESS = "success",
  // I've added this for in progress messages that we can prioritize
  // in preclass_test_messages.ts
  IN_PROGRESS = "in_progress",
  FAIL = "fail",
  ABORT = "abort",
  EXCEPTION = "exception",
}

export type PreclassTestResultType = {
  name: PreclassTestNameType;
  category: PreclassTestCategoryType;
  outcome: PreclassTestOutcomeType;
  error?: PreclassTestErrorsType;
  message?: string;
  // A few tests have additional data that can be useful for investigation
  data?: {
    stats?: CpuModelAndScoreType;
    cpus?: number;
    memory?: number;
    message?: string;
  };
};

export type LatestPreclassCheckResultType = {
  eventId: string;
  outcome: string;
  tests: PreclassTestResultType[];
};
